import { useRef, useEffect, useState, useCallback } from "react";

const Why = ({ whyref, obs, statrun }) => {
  const yearRef = useRef();
  const studentRef = useRef();
  const [statsTime, setTime] = useState(0);

  const replaceOnlyText = useCallback((element, newText) => {
    if (!element) return;

    const nodes = element.childNodes;

    for (let node of nodes) {
      if (
        node.nodeType === Node.TEXT_NODE &&
        node.textContent.trim() !== ""
      ) {
        node.textContent = newText;
        return;
      }
    }

    element.prepend(document.createTextNode(newText));
  }, []);

  const animateValue = useCallback(
    (obj, start, end, duration) => {
      if (!obj) return;

      let startTimestamp = null;

      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;

        const progress = Math.min(
          (timestamp - startTimestamp) / duration,
          1
        );

        replaceOnlyText(
          obj,
          Math.floor(progress * (end - start) + start)
        );

        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };

      window.requestAnimationFrame(step);
    },
    [replaceOnlyText]
  );

  useEffect(() => {
    if (statrun && statsTime < 2) {
      animateValue(yearRef.current, 0, 15, 500);
      animateValue(studentRef.current, 0, 100, 1000);
      setTime((prev) => prev + 1);
    }
  }, [statrun, statsTime, animateValue]);

  useEffect(() => {
	const currentElement = whyref?.current;
  
	if (currentElement && obs) {
	  obs.observe(currentElement);
	}
  
	return () => {
	  if (currentElement && obs) {
		obs.unobserve(currentElement);
	  }
	};
  }, [whyref, obs]);

  return (
    <div className="whyWrapper">
      <div className="gd"></div>

      <div className="why-container default-container">
        <div className="content-block">
          <p className="why-title">Why Choose Us</p>

          {/* Existing content remains unchanged */}

          <div className="stats-container" ref={whyref}>
            <div className="stats-block">
              <div className="stats-number" ref={yearRef}>
                15
              </div>
              <div className="stats-title">
                {" "}
                years of vedic Association
              </div>
            </div>

            <div className="stats-block">
              <div className="stats-number" ref={studentRef}>
                0 <span>%</span>
              </div>
              <div className="stats-title">Satisfaction Rate</div>
            </div>
          </div>
        </div>

        <div className="img-block">
          <img
            src="/astronDemo images/choose us.jpg"
            alt="astron-chooseus"
          />
        </div>
      </div>

      <div className="gd"></div>
    </div>
  );
};

export default Why;